import { render } from "./Jitsi.vue?vue&type=template&id=7e88a34a"
import script from "./Jitsi.vue?vue&type=script&lang=js"
export * from "./Jitsi.vue?vue&type=script&lang=js"
script.render = render

export default script